import { Tabs } from "antd";
import React, { useEffect, useState } from "react";

import { Navigate, useLocation, useNavigate } from "react-router";

import FilterComponent from "../../JobModuleComponent/FilterComponent/FilterComponent";
import "./AuthTab.css";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { updateFilterValues } from "../../../redux/Transcribe/TranscribeAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function AuthTab() {
  // const [activeTab, setActiveTab] = useState("inprogress"); // Manage active tab state
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  const activeTabFromURL = location.pathname.split("/").pop() || "inprogress";
  const currentFilterValues = useSelector((state: RootState) => state.TranscribeState.filterValues);

  const [activeTab, setActiveTab] = useState(activeTabFromURL);

  useEffect(() => {
    setActiveTab(activeTabFromURL);
  }, [activeTabFromURL]);

  const tabItems = [
    {
      label: "In Progress",
      key: "inprogress",
      keyValue: 0,
    },
    {
      label: "Completed",
      key: "completed",
      keyValue: 3,
    },
    {
      label: "Archived",
      key: "archived",
      keyValue: 5,
    },
  ];
  return (
    <div className="d-flex align-items-center justify-content-between px-4">
      <div className="d-flex">
        {tabItems.map((tab) => (
          <div
            key={tab.key}
            className={`tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => {
              setActiveTab(tab.key);
              navigate(tab.key);
              dispatch(updateFilterValues({ ...currentFilterValues, StatusId: tab.keyValue })); // Update filter values in Redux store
            }}>
            <b>{tab.label}</b>
          </div>
        ))}
      </div>

      <div className="d-flex align-items-center gap-3">
        <FilterComponent tab={activeTab} />
      </div>
    </div>
  );
}

export default AuthTab;
